<template>
  <v-simple-table class="mx-auto mt-4" style="max-width: 400px">
    <template v-slot:default>
      <tbody>
        <tr v-for="pck of selectedPackages" :key="pck.packageName + '-selectedPackages'">
          <td>
            <span v-if="pck.amountSelectable && pck.amount" class="mr-1"> {{ pck.amount }}x </span>
            <span>{{ pck.packageName }}</span>
          </td>
          <td style="text-align: end">
            <span v-if="isPelviAnteilPackage(pck)">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mr-1" @click.stop icon>
                    <v-icon v-on="on" v-bind="attrs">mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span> Regulärer Jahrespreis: {{ displayCurrency(pck.usualPriceYear) }} </span>
              </v-tooltip>
              {{ displayCurrency(calcPelvixPrice(pck)) }}
            </span>

            <span v-else>
              <span v-if="pck.amountSelectable && pck.amount">
                <span
                  v-if="
                    pck.usualPrice &&
                    (pck.calculateWithEndDate || (pck.calculateWithEndDateSixMonths && parseInt(pck.price) !== parseInt(pck.usualPrice)))
                  ">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mr-1" @click.stop icon>
                        <v-icon v-on="on" v-bind="attrs">mdi-sale-outline</v-icon>
                      </v-btn>
                    </template>
                    <span> Regulärpreis: {{ displayCurrency(pck.amount * pck.usualPrice) }} </span>
                  </v-tooltip>
                </span>
                {{ displayCurrency(pck.amount * parseInt(pck.price)) }}
              </span>
              <span v-else>
                <span
                  v-if="
                    pck.usualPrice &&
                    (pck.calculateWithEndDate || (pck.calculateWithEndDateSixMonths && parseInt(pck.price) !== parseInt(pck.usualPrice)))
                  ">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mr-1" @click.stop icon>
                        <v-icon v-on="on" v-bind="attrs">mdi-sale-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Regulärpreis: {{ displayCurrency(pck.usualPrice) }}</span>
                  </v-tooltip>
                </span>
                {{ displayCurrency(pck.price) }}
              </span>
            </span>
          </td>
        </tr>
        <tr
          style="background-color: var(--v-primary); font-weight: bold; letter-spacing: 0.8px"
          class="white--text"
          v-if="parseInt(totalPrice) !== parseInt(fullValue)">
          <td>Gesamtpreis (über Laufzeit)</td>
          <td style="text-align: end">{{ displayCurrency(fullValue) }}</td>
        </tr>

        <tr style="background-color: var(--v-primary); font-weight: bold; letter-spacing: 0.8px" class="white--text">
          <td>Gesamt (heute fällig)</td>
          <td style="text-align: end">{{ displayCurrency(totalPrice) }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
import { roundToNearestFiveCents } from "@/moduls/currency/currency.js"
export default {
  props: {
    possibilities: {
      type: Object,
      required: true,
    },
    totalPrice: {
      // umbenannt von 'total' und Typ geändert
      type: Number,
      required: true,
    },
    fullValue: {
      // Typ geändert
      type: Number,
      required: true,
    },
    selectedPackages: {
      default: [],
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    leftTrainingYears() {
      // this.possibilities.duration.years - (this.possibilities.trainingDurationInYears + 1)

      return this.possibilities && this.possibilities.duration
        ? this.possibilities.duration.years - (this.possibilities.trainingDurationInYears + 1)
        : 0
    },
    // HELFERMETHODE, um den Code im Template sauber zu halten
    isPelviAnteilPackage(pck) {
      if (!pck || !pck.packageName) return false
      return pck.packageName.toLowerCase().includes("pelvi") && pck.packageName.toLowerCase().includes("anteil")
    },
    // KOPIERTE BERECHNUNGSMETHODE aus der Hauptkomponente
    calcPelvixPrice(pck) {
      return pck.price - this.leftTrainingYears() * pck.usualPriceYear
    },
    displayCurrency(amount) {
      return roundToNearestFiveCents(amount)
    },
  },
}
</script>
